interface RecordingIndicatorProps {
  status: 'idle' | 'recording' | 'uploading' | 'done' | 'error'
}

export function RecordingIndicator({ status }: RecordingIndicatorProps) {
  if (status === 'recording') {
    return (
      <div className="flex items-center gap-1.5 rounded-md bg-hf-card border border-hf-line px-2 py-1 text-xs font-semibold text-red-600 shadow-[0_10px_30px_-15px_rgba(20,19,15,0.25)]">
        <span className="h-2 w-2 animate-pulse rounded-full bg-red-500" />
        REC
      </div>
    )
  }

  if (status === 'uploading') {
    return (
      <div className="rounded-md bg-hf-card border border-hf-line px-2 py-1 text-xs text-hf-muted shadow-[0_10px_30px_-15px_rgba(20,19,15,0.25)]">
        Uploading...
      </div>
    )
  }

  return null
}
